import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {CriticalUpdateBanner} from './criticalUpdateBanner';

/*
 * Selectors.
 */

function getCriticalUpdateReloadTime(state: AppState) {
  return state.update.criticalUpdateReloadTime;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  criticalUpdateReloadTime: getCriticalUpdateReloadTime,
}));

export const CriticalUpdateBannerContainer = connect(mapStateToProps)(CriticalUpdateBanner);
